import WrappedApplePayButton from './WrappedApplePayButton';

export default WrappedApplePayButton;
